export const agenciesHeader = [
    "AGENCY",
    "TYPE",
    "Number of Applications with Conversation ID",
    "Number of Test Applications",
    "Number of Knocked Out Applications",
    "Number of Actual Applications",
    "Number of Approved Applications",
    "Placement Ratio (%)",
    "Amount of Target Premium ($)",
    "Number of RTU Applications",
    "%RTU Applications",
    "Number of Declines",
    "%Decline Applications",
    "Number of AbandonedDueToPriceChange Applications",
    "%AbandonedDueToPriceChange Applications",
    "Number of In Process Applications",
    "%In Process Applications",
    "Average 3PS Time (Minutes)"
]